/** Shared HQ portal helpers (not product pages). */

export const HQ_PORTALS = ["executive", "workspace", "partner"];

export function portalStoragePrefix(portal) {
  return `enterprise_${portal}_`;
}

export function clearPortalStorage(portal) {
  if (typeof localStorage === "undefined") return;
  const prefix = portalStoragePrefix(portal);
  const keys = [];
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (key && key.startsWith(prefix)) keys.push(key);
  }
  keys.forEach((key) => localStorage.removeItem(key));
}

/** Remove legacy JWT copies — session uses HttpOnly cookies. */
export function stripPortalJwtFromStorage(portal) {
  if (typeof localStorage === "undefined") return;
  localStorage.removeItem(`${portalStoragePrefix(portal)}AUTH_TOKEN`);
}

export function stripAllPortalJwtsFromStorage() {
  HQ_PORTALS.forEach((portal) => stripPortalJwtFromStorage(portal));
  localStorage.removeItem("enterprise_salon_AUTH_TOKEN");
  purgeLegacyNxtfaceAdminStorage();
}

/** Remove legacy NXTFace Admin localStorage keys (app removed). */
export function purgeLegacyNxtfaceAdminStorage() {
  if (typeof localStorage === "undefined") return;
  const keys = [];
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (key && key.startsWith("enterprise_nxtface_")) keys.push(key);
  }
  keys.forEach((key) => localStorage.removeItem(key));
}

export const PORTAL_HEADER = "X-Enterprise-Portal";
